export default __webpack_public_path__ + "static/media/mic-off-red.38cf708e.svg";